export default "__VITE_PUBLIC_ASSET__6069cea7__"